if (!customElements.get('product-page')) {
  customElements.define('product-page', class ProductPage extends HTMLElement {
    constructor() {
      super();
      this.bosapinUtils = document.querySelector('bosapin-utils');
    }

    connectedCallback() {
      this.init();
    }

    postalCodeUiMessageKey(result) {
      if (result.message) {
        return result.message;
      }
      const availMsg = result.availability && result.availability.message;
      if (availMsg) {
        return availMsg;
      }
      return 'error';
    }

    getSuccessMessageForAvailability(result) {
      const key = result.availability && result.availability.message;
      const mapping = window.postalCodeErrorMessages;
      if (key && mapping && mapping[key]) {
        return mapping[key];
      }
      return this.getPostalCodeMessage('available');
    }

    applyVariantStockFromResponse(variants) {
      if (!variants || !variants.length) {
        return;
      }

      const addToCartButton = this.querySelector('#add-to-cart-button');
      const variantIdInput = document.querySelector('input[name="id"]');
      const quantityInput = document.querySelector('.quantity__input');
      const variantId = variantIdInput ? variantIdInput.value : null;
      const quantity = parseInt(quantityInput && quantityInput.value ? quantityInput.value : '1', 10);
      let current = variants.find(function (v) {
        const vId = parseInt(v.shopify_variant_id || v.variant_id || v.id, 10);
        return vId === parseInt(variantId, 10);
      });

      // First availability apply: select warehouse-preferred in-stock variant (falls back to first in-stock).
      // Skip when the URL already pins a variant (?variant=...).
      let shouldSelectPreferred = false;
      if (!this._preferredDefaultApplied) {
        this._preferredDefaultApplied = true;
        const urlVariantId = parseInt(new URLSearchParams(window.location.search).get('variant'), 10);
        if (!urlVariantId) {
          const qty = (v) => parseInt(v.quantity_available, 10) || 0;
          const preferredInStock = variants.find((v) => v.is_preferred && qty(v) > 0);
          const firstInStock = variants.find((v) => qty(v) > 0);
          const pick = preferredInStock || firstInStock;
          if (pick) {
            const pickId = parseInt(pick.shopify_variant_id || pick.variant_id || pick.id, 10);
            const currentId = current
              ? parseInt(current.shopify_variant_id || current.variant_id || current.id, 10)
              : null;
            if (pickId !== currentId) {
              current = pick;
              shouldSelectPreferred = true;
            }
          }
        }
      }

      if (!current) {
        return;
      }

      if (addToCartButton) {
        const label = addToCartButton.querySelector('.add-to-cart-button-text');
        const currentAvailable = current ? parseInt(current.quantity_available, 10) : 0;
        if (current && currentAvailable >= quantity) {
          addToCartButton.disabled = false;
          if (label) {
            label.innerHTML = window.variantStrings.addToCart;
          }
        } else {
          addToCartButton.disabled = true;
          if (label) {
            label.innerHTML = window.variantStrings.soldOut;
          }
        }
      }

      this.querySelectorAll('.variant-label').forEach(element => {
        element.classList.add('unavailable');
        element.classList.add('hidden');
      });

      const lang = typeof Shopify !== 'undefined' ? Shopify.lang : 'en';
      const self = this;
      
      const currentTranslatedOptions = this.getTranslatedOptions(current);

      const currentStorefront = this.storefrontVariantFor(current);
      const currentOption1 = currentStorefront ? currentStorefront.option1 : currentTranslatedOptions.option1Value;

      variants.forEach(variant => {
        const isPreferred = variant.is_preferred;
        const availableQty = parseInt(variant.quantity_available, 10) || 0;
        const storefrontVariant = this.storefrontVariantFor(variant);
        const translatedOptions = this.getTranslatedOptions(variant);
        const option1Value = storefrontVariant ? storefrontVariant.option1 : translatedOptions.option1Value;
        const option2Value = storefrontVariant ? storefrontVariant.option2 : translatedOptions.option2Value;
        const element = this.optionLabel(1, option1Value)
          || self.querySelector(`[data-option-name="${translatedOptions.option1Title}"][data-option-value="${translatedOptions.option1Value}"]`);
        element?.classList.remove('hidden');
        if (element && availableQty > 0) {
          element.classList.remove('unavailable');
        }
        if (isPreferred && element) {
          element.querySelector('.option-preferred-icon')?.classList.remove('hidden');
        }

        if (option1Value === currentOption1) {
          const element = this.optionLabel(2, option2Value)
            || self.querySelector(`[data-option-name="${translatedOptions.option2Title}"][data-option-value="${translatedOptions.option2Value}"]`);
          element?.classList.remove('hidden');
          if (element && availableQty > 0) {
            element.classList.remove('unavailable');
          }
          if (isPreferred && element) {
            element.querySelector('.option-preferred-icon')?.classList.remove('hidden');
          }
        }
      });

      // Check radios from the storefront variant so the change event resolves that variant id.
      self.querySelectorAll('variant-radios .product-form__input').forEach(element => {
        const optionId = element.dataset.optionId;
        let optionValue = currentStorefront ? currentStorefront['option' + optionId] : null;
        if (optionValue == null && current.translated_options) {
          const optionValueKey = 'option' + optionId + '_value';
          const translated = current.translated_options[lang] || current.translated_options['default'] || {};
          optionValue = translated[optionValueKey];
        }
        if (optionValue == null) return;

        const selectedOption = Array.from(element.querySelectorAll('input')).find(function (input) {
          return input.value === String(optionValue);
        });
        if (selectedOption) {
          selectedOption.checked = true;
        }
      });

      // Commit preferred selection so variant id / price / media stay in sync
      if (shouldSelectPreferred) {
        const variantPicker = self.querySelector('variant-radios, variant-selects');
        if (variantPicker) {
          variantPicker.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    getDeliveryDateRange(result) {
      const availability = result && result.availability;
      if (!availability) {
        return null;
      }

      const dates = [];
      const addDates = (entries) => {
        if (!Array.isArray(entries)) {
          return;
        }
        entries.forEach((entry) => {
          const date = entry && (entry.date || entry);
          if (date) {
            dates.push(String(date).trim());
          }
        });
      };

      addDates(availability.dates_standard);
      addDates(availability.dates_flex);

      const unique = Array.from(new Set(dates)).sort();
      if (!unique.length || unique.length === 1) {
        return null;
      }

      const parseDate = (s) => new Date(`${s}T11:00:00`);
      const first = parseDate(unique[0]);
      const last = parseDate(unique[unique.length - 1]);
      const locale = (typeof document !== 'undefined' && document.documentElement.lang)
        || (typeof Shopify !== 'undefined' ? Shopify.lang : 'en');
      const monthFmt = new Intl.DateTimeFormat(locale, { month: 'short' });

      return {
        from: { month: monthFmt.format(first), day: String(first.getDate()).padStart(2, '0') },
        to: { month: monthFmt.format(last), day: String(last.getDate()).padStart(2, '0') }
      };
    }

    storefrontVariantFor(apiVariant) {
      if (!apiVariant) return null;
      if (!this._storefrontVariantsById) {
        this._storefrontVariantsById = {};
        this.querySelectorAll('variant-radios script[type="application/json"], variant-selects script[type="application/json"]').forEach((script) => {
          try {
            const parsed = JSON.parse(script.textContent);
            if (!Array.isArray(parsed)) return;
            parsed.forEach((variant) => {
              this._storefrontVariantsById[String(variant.id)] = variant;
            });
          } catch (_) {}
        });
      }
      const id = parseInt(apiVariant.shopify_variant_id || apiVariant.variant_id || apiVariant.id, 10);
      return id ? this._storefrontVariantsById[String(id)] || null : null;
    }

    optionLabel(position, value) {
      if (value == null || value === '') return null;
      const field = this.querySelector('.product-form__input[data-option-id="' + position + '"]');
      if (!field) return null;
      const wanted = String(value);
      return Array.from(field.querySelectorAll('.variant-label')).find(function (label) {
        return label.dataset.optionValue === wanted;
      }) || null;
    }

    getTranslatedOptions(variant) {
      const lang = typeof Shopify !== 'undefined' ? Shopify.lang : 'en';

      const translatedOptions = variant.translated_options[lang] ? variant.translated_options[lang] : variant.translated_options['default'];

      const option1Title = translatedOptions.option1_title ?? variant.translated_options['default'].option1_title;
      const option1Value = translatedOptions.option1_value ?? variant.translated_options['default'].option1_value;
      const option2Title = translatedOptions.option2_title ?? variant.translated_options['default'].option2_title;
      const option2Value = translatedOptions.option2_value ?? variant.translated_options['default'].option2_value;
      const option3Title = translatedOptions.option3_title ?? variant.translated_options['default'].option3_title;
      const option3Value = translatedOptions.option3_value ?? variant.translated_options['default'].option3_value;
      
      return {
        option1Title,
        option1Value,
        option2Title,
        option2Value,
        option3Title,
        option3Value
      };
    }

    applyTreasyAvailabilityUI(result) {
      const disabledNoPostalCodeButton = this.querySelector('#disabledNoPostalCode');
      const variantSelectElements = this.querySelectorAll('variant-selects, variant-radios');
      const klaviyoForm = this.querySelector('.klaviyo-form-no-location-found');

      if (klaviyoForm && !klaviyoForm.classList.contains('hidden')) {
        klaviyoForm.classList.add('hidden');
      }

      if (result.message === 'postal_code_found_in_another_franchise') {
        const company = result.company != null ? result.company : (result.data && result.data.company);
        const website = result.website != null ? result.website : (result.data && result.data.website);
        if (window.autoRedirectToCorrectStore && website) {
          window.location.href = website + window.location.pathname.replace('/en/', '/').replace('/fr/', '/') + '?postal_code=' + result.postal_code;
          return;
        }
        this._lastAvailabilityVariants = null;
        this.showInAnotherFranchiseMessage(company || '', website || '', result.postal_code);
        if (disabledNoPostalCodeButton) {
          disabledNoPostalCodeButton.style.display = 'block';
        }
        variantSelectElements?.forEach(element => element?.disableSelection?.());
        return;
      }

      const offSeasonMode = Shopify.offSeasonMode;
      if (offSeasonMode === 'true') {
        result = {"success":false,"message":"postal_code_not_found"};
      }

      if (result.success === true) {
        this._lastAvailabilityVariants = result.variants || null;
        this.showPostalCodeMessage(this.getSuccessMessageForAvailability(result), false);
        if (disabledNoPostalCodeButton) {
          disabledNoPostalCodeButton.style.display = 'none';
        }
        this.applyVariantStockFromResponse(result.variants);
        variantSelectElements?.forEach(element => element?.enableSelection?.());

        const deliveryInfo = this.querySelector('.delivery-info');
        if (deliveryInfo) {
          const dateRange = this.getDeliveryDateRange(result);
          const fromDeliveryDate = this.querySelector('[data-from-delivery-date]');
          const toDeliveryDate = this.querySelector('[data-to-delivery-date]');
          if (fromDeliveryDate && toDeliveryDate && dateRange) {
            fromDeliveryDate.textContent = dateRange.from.day;
            toDeliveryDate.textContent = dateRange.to.day;
            const fromMonthTitle = fromDeliveryDate.closest('.delivery-info__date')?.querySelector('.delivery-info__date-title');
            const toMonthTitle = toDeliveryDate.closest('.delivery-info__date')?.querySelector('.delivery-info__date-title');
            if (fromMonthTitle) {
              fromMonthTitle.textContent = dateRange.from.month;
            }
            if (toMonthTitle) {
              toMonthTitle.textContent = dateRange.to.month;
            }

            deliveryInfo.classList.remove('hidden');
          }
        }
        
        return;
      }

      this._lastAvailabilityVariants = null;
      const msgKey = this.postalCodeUiMessageKey(result);
      this.showPostalCodeMessage(this.getPostalCodeMessage(msgKey), msgKey !== 'available');
      if (klaviyoForm && (msgKey === 'postal_code_not_found' || Shopify.offSeasonMode === 'true')) {
        // only show if the klaviyo-form- element exists and is not empty. search using start of klaviyo-form-
        const klaviyoFormElement = klaviyoForm.querySelector('[class*="klaviyo-form-"]');
        if (klaviyoFormElement && klaviyoFormElement.innerHTML.trim() !== '') {
          klaviyoForm.classList.remove('hidden');
        }
      }
      if (disabledNoPostalCodeButton) {
        disabledNoPostalCodeButton.style.display = 'block';
      }
      variantSelectElements?.forEach(element => element?.disableSelection?.());
    }

    init() {
      const inputId = this.querySelector('input[name="id"]');
      if (inputId) {
        inputId.addEventListener('change', () => {
          if (this._lastAvailabilityVariants && this._lastAvailabilityVariants.length) {
            this.applyVariantStockFromResponse(this._lastAvailabilityVariants);
          }
        });
      }

      const postalInput = this.querySelector('#postal-code__input');
      if (postalInput) {
        const stored = localStorage.getItem('postalCode');
        if (stored && stored !== '') {
          postalInput.value = stored;
        } else {
          const postalCodeContainer = this.querySelector('.postal-code-container');
          if (postalCodeContainer) {
            postalCodeContainer.classList.remove('hidden');
          }
        }

        postalInput.addEventListener('change', () => {
          this.clearPostalCodeMessages();
        });

        postalInput.addEventListener('input', () => {
          const postalSubmit = this.querySelector('#postal-code__submit');
          if (postalSubmit && postalSubmit.disabled) {
            postalSubmit.removeAttribute('disabled');
          }
        });
      }

      // On validate postal code button click
      const postalSubmit = this.querySelector('#postal-code__submit');
      if (postalSubmit) {
        postalSubmit.addEventListener('click', this.postalCodeSubmit.bind(this));
      }

      if (inputId || postalInput || postalSubmit) {
        // Look for old postal code
        let postalCode = localStorage.getItem("postalCode");

        // if we have old postal we set in input
        if(postalCode && postalCode !== '') {
          const postalCodeInput = this.querySelector('#postal-code__input');
          postalCodeInput.value = postalCode;

          this.showPostalCodeMessage(this.getPostalCodeMessage('available'), false);
          const disabledNoPostalCodeButton = this.querySelector('#disabledNoPostalCode');
          const variantSelectElements = this.querySelectorAll('variant-selects, variant-radios');

          if (disabledNoPostalCodeButton) {
            disabledNoPostalCodeButton.style.display = 'none';
          }

          this.validatePostalCode();
        }
      } else {
        const postalCodeContainer = this.querySelector('.postal-code-container');
        if (postalCodeContainer) {
          postalCodeContainer.classList.remove('hidden');
        }
      }
    }

    async validatePostalCode(button) {
      if (!button) {
        button = this.querySelector('#postal-code__submit');
      }

      const postalCodeInput = document.querySelector('#postal-code__input');
      const formatted = this.bosapinUtils.normalizePostalCode(postalCodeInput && postalCodeInput.value);
      if (!this.bosapinUtils.getRegexResult(formatted)) {
        this.showPostalCodeMessage(this.getPostalCodeMessage('format'), true);
        button.disabled = true;
        return;
      }

      const productIdInput = document.querySelector('input[name="product-id"]');
      const productId = productIdInput ? productIdInput.value : null;
      if (!productId) {
        button.disabled = true;
        return;
      }

      window.postalCodeLocation = 'product';
      const result = await this.bosapinUtils.fetchTreasyAvailability(formatted, productId);
      this.bosapinUtils.syncPostalAvailabilitySession(formatted, result);
      this.applyTreasyAvailabilityUI(result);

      // Update Postal code badge
      const postalCodeBadge = document.querySelector('postal-code-badge');
      if (postalCodeBadge) {
        postalCodeBadge.currentPostalCode = formatted;
        postalCodeBadge.renderDisplayValue();
      }

      button.disabled = true;
    }

    async postalCodeSubmit(e) {
      const button = e.target;
      if (button.disabled) {
        return;
      }

      await this.validatePostalCode(button);
    }

    clearPostalCodeMessages() {
      const errorElement = this.querySelector('.post-code__single-error');
      if (!errorElement) {
        return;
      }
      errorElement.innerText = '';
      errorElement.classList.remove('show');
      errorElement.classList.remove('text-success', 'text-error');
      const variantSelectElements = this.querySelectorAll('variant-selects, variant-radios');
      if (variantSelectElements.length > 0) {
        variantSelectElements.forEach(element => element?.disableSelection?.());
      }

      const klaviyoForm = this.querySelector('.klaviyo-form-no-location-found');
      if (klaviyoForm && !klaviyoForm.classList.contains('hidden')) {
        klaviyoForm.classList.add('hidden');
      }
    }

    getPostalCodeMessage(message) {
      const mapping = window.postalCodeErrorMessages;

      let selectedMessage = mapping['error'];
      if (mapping[message]) {
        selectedMessage = mapping[message];
      }

      return selectedMessage;
    }

    showPostalCodeMessage(message, error) {
      this.clearPostalCodeMessages();

      const errorElement = this.querySelector('.post-code__single-error');
      const postalCodeContainer = this.querySelector('.postal-code-container');

      if (!errorElement) {
        return;
      }

      errorElement.innerHTML = message;

      if (error) {
        errorElement.classList.add('text-error');
        if (postalCodeContainer) {
          postalCodeContainer.classList.remove('hidden');
        }
      } else {
        errorElement.classList.add('text-success');
        if (postalCodeContainer) {
          postalCodeContainer.classList.add('hidden');
        }
      }

      errorElement.classList.add('show');
    }

    showInAnotherFranchiseMessage(name, website, postalCode) {
      let defaultMessage = this.getPostalCodeMessage('postal_code_found_in_another_franchise');

      let message = defaultMessage.replace('__FRANCHISE__', name);

      if (postalCode) {
        website = website + '?postal_code=' + postalCode;
      }

      message = message.replace('__URL__', website);

      this.showPostalCodeMessage(message, true);
    }
  });
}